import React from 'react';
import { Checkbox, CheckboxProps } from '@mantine/core';

export function ECheckbox({ ...props }: CheckboxProps) {
    return (
        <Checkbox
            {...props}
        />
    )
}
